'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSection;
function createSection() {
    var fixture = init();

    function init() {
        return {
            id: 0,
            displayCondition: { type: 'true' },
            condition: { type: 'true' }
        };
    }

    return {
        setId: function setId(id) {
            fixture.id = id;
            return this;
        },
        setDisplayCondition: function setDisplayCondition(condition) {
            fixture.displayCondition = condition;
            return this;
        },
        setOpenRestAvailability: function setOpenRestAvailability(availability) {
            fixture.properties = {
                'com.implied2.spice': '{"availability":' + JSON.stringify(availability) + '}'
            };
            return this;
        },
        setChildren: function setChildren(children) {
            fixture.children = children;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}